import React from 'react'
import { makeStyles, createStyles, withStyles, Drawer, Box, Typography, IconButton } from '@material-ui/core'
import classnames from 'classnames'
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined'
const CustomDrawer = withStyles((theme) => ({
  paperAnchorBottom: {
    borderStartEndRadius: theme.spacing(3),
    borderStartStartRadius: theme.spacing(3),
    // padding: theme.spacing(2),
    // paddingBottom: theme.spacing(4.5),
  },
  paperAnchorRight: {
    width: '30%',
  },
}))(Drawer)

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {},
    header: {
      // display: 'flex',
      position: 'relative',
      // alignItems: 'center',
      height: theme.spacing(8),
      // justifyContent: 'space-between',
      fontWeight: theme.typography.fontWeightBold,
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(2),
      // background: theme.palette.secondary.main,
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      borderBottom: '1px solid #F9FAFB',
    },
    headerFaq: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      fontWeight: theme.typography.fontWeightBold,
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
    },
    isAgreement: {
      // display: 'flex',
      position: 'relative',
      // alignItems: 'center',
      height: theme.spacing(5),
      // justifyContent: 'space-between',
      fontWeight: theme.typography.fontWeightBold,
      paddingBottom: theme.spacing(2),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    title: {
      textAlign: 'center',
      marginTop: theme.spacing(2),
      // color: '#ffff',
      fontWeight: theme.typography.fontWeightBold,
    },
    title2: {
      textAlign: 'center',
      marginTop: theme.spacing(2),
      fontWeight: theme.typography.fontWeightBold,
    },

    closeIcon: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1.5),
      // '& path': {
      //   fill: '#fff',
      // },
    },
    closeIcon2: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1.5),
    },
  }),
)

const EDrawer = ({ children, className, title, onClose, isOrder, mask, anchor, isAgreement, ...rest }) => {
  const classes = useStyles()
  return (
    <CustomDrawer
      anchor={anchor ? anchor : 'bottom'}
      className={classnames((classes.root, className))}
      onClose={mask ? null : onClose}
      {...rest}
    >
      {isAgreement ? (
        <Box className={classes.isAgreement}>
          <Typography className={classes.title2} variant="h3" noWrap>
            {title}
          </Typography>

          <IconButton size="small" aria-label="close button" onClick={onClose} className={classes.closeIcon2}>
            <CancelOutlinedIcon />
          </IconButton>
        </Box>
      ) : (
        <Box className={isOrder ? classes.headerFaq : classes.header}>
          <Typography className={classes.title} variant="h3" noWrap>
            {title}
          </Typography>
          <IconButton size="small" aria-label="close button" onClick={onClose} className={classes.closeIcon}>
            <CancelOutlinedIcon />
          </IconButton>
        </Box>
      )}
      <Box p={2}> {children}</Box>
    </CustomDrawer>
  )
}

export default EDrawer
